import $ from 'jquery';

import MenuDrawer from 'chairisher/component/menudrawer';
import ModalViewHelper from 'chairisher/view/helper/modal';

import { getVariantChoices } from 'chairisher/context/product';
import { AmplitudeEventProperty, logAmplitudeEvent, PDPSection } from 'chairisher/util/analytics';
import { isMaxPhone } from 'chairisher/util/mediaquery';

/**
 * Binds a drawer for viewing variants on the product detail page.
 * This is extracted into a separate function so that it can be lazy-loaded as not all products have variants.
 */
export default function bindVariantDrawer() {
    const menuDrawer = new MenuDrawer({ $el: $('.js-variant-drawer') });
    menuDrawer.attach();

    const $selectedVariantColor = $('.js-selected-variant-color');
    const hasVariant = new URL(window.location).searchParams.has('variant');
    if (hasVariant && $selectedVariantColor.length && isMaxPhone()) {
        $selectedVariantColor.get(0).scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
        });
    }

    $(window).click(() => {
        if (menuDrawer.isVisible()) {
            menuDrawer.hide();
            $('.js-variant-drawer').removeClass('collapse in');
            ModalViewHelper.toggleBackdrop(false);
        }
    });

    menuDrawer.getEl().click((event) => {
        event.stopPropagation();
    });

    $('.js-variant-options-info').on('click', ({ currentTarget }) => {
        const variantOption = $(currentTarget).find('.js-variant-dropdown-display');
        const variantOptionNumber = variantOption.data('variant-number');
        const totalOptionNumber = variantOption.data('variant-count');

        window.setTimeout(() => {
            menuDrawer.show();
            ModalViewHelper.toggleBackdrop(true);
        }, 100);

        for (let i = 0; i <= totalOptionNumber; i += 1) {
            $(`#js-variant-option-label-${i}, #js-variants-choices-div-${i}`).toggleClass(
                'hidden',
                i !== variantOptionNumber,
            );
        }
    });

    $('.js-close-variant-drawer').on('click', () => {
        menuDrawer.hide();
        $('.js-variant-drawer').removeClass('collapse in');
        ModalViewHelper.toggleBackdrop(false);
    });

    const selectedVariantColorDisplay = $('.variant-color-display').text();

    $('.js-variant-color-box').on('mouseenter mouseleave', (e) => {
        const isHover = e.type === 'mouseenter';
        let $variantImage = $('.js-product-images .js-variant-preview');

        if (isHover) {
            const colorDisplayText = $(e.currentTarget).data('colors-value');
            $('.variant-color-display').text(colorDisplayText);

            const variantChoices = getVariantChoices();
            const imgUrlSrc = variantChoices[colorDisplayText][1].src;
            const imgUrlSrcSet = variantChoices[colorDisplayText][1].srcset;

            if (!$variantImage.length) {
                $variantImage = $('<img>', {
                    class: 'js-variant-preview variant-preview',
                });
            }
            $variantImage
                .attr({
                    src: imgUrlSrc,
                    srcset: imgUrlSrcSet,
                })
                .css({
                    height: 'auto',
                    left: '50%',
                    margin: '0 auto',
                    position: 'absolute',
                    top: 0,
                    transform: 'translateX(-50%)',
                    width: '60%',
                    zIndex: 999,
                })
                .appendTo('.js-product-images');
        } else {
            $('.variant-color-display').text(selectedVariantColorDisplay);
            $variantImage.remove();
        }

        $('#js-variant-color-hover-options-div').toggleClass('hidden', !isHover);
    });

    $('.js-variant-option-link, .js-variant-color-box').on('click', (e) => {
        const $variantOption = $(e.currentTarget);
        const optionUrl = $variantOption.data('option-url');

        logAmplitudeEvent('variant - select', {
            [AmplitudeEventProperty.CTA_POSITION]: PDPSection.VARIANT_OPTIONS,
            [AmplitudeEventProperty.CTA_URL]: optionUrl,
            [AmplitudeEventProperty.VARIABLE_ATTRIBUTE_NAME]: $variantOption.data('option-name'),
            [AmplitudeEventProperty.VARIABLE_ATTRIBUTE_VALUE]: $variantOption.data('option-display'),
        });
        const variantUrlWithSearchParams = new URL(optionUrl);
        variantUrlWithSearchParams.searchParams.set('variant', 'true');
        window.location.replace(variantUrlWithSearchParams);
    });
}
